/**
 * Format a measure-moment label as "Title (position)".
 *
 * Used for the x-axis / heading labels of effect & research charts so the
 * user-given measure-moment title is shown together with its position,
 * e.g. "Voormeting (1)", "Nameting (2)".
 *
 * Falls back to "Meetmoment {position}" when no title is known, and to the
 * bare title when no position is known.
 *
 * @param {string} [title] - The measure moment's user-given title (MeasureMoments.Title).
 * @param {number|string} [position] - The measure moment's position (MeasureMoments.Position).
 * @returns {string}
 */
const formatMomentLabel = (title, position) => {
    const trimmedTitle = typeof title === 'string' ? title.trim() : '';
    const hasPosition = position !== undefined && position !== null && `${position}` !== '';

    if (trimmedTitle) {
        return hasPosition ? `${trimmedTitle} (${position})` : trimmedTitle;
    }

    return hasPosition ? `Meetmoment ${position}` : 'Meetmoment';
};

export default formatMomentLabel;
